var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"36","height":"36","viewBox":"0 0 36 36"}},[_c('path',{staticClass:"a",attrs:{"d":"M18,0A18,18,0,1,0,36,18,18.053,18.053,0,0,0,18,0Zm0,35A17,17,0,1,1,35,18,16.986,16.986,0,0,1,18,35Z"}}),_vm._v(" "),_c('rect',{staticClass:"a",attrs:{"width":"4.6","height":"1.5","transform":"translate(15.5 18)"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }